<template>
    <div id="blackList">
        <v-container grid-list-md fluid class="pt-0">
          <v-layout>
            <v-flex class="xs12 sm12 mb-5">
              <v-btn fab absolute right class="mr-3 pf-btn-fab" @click="addIP">
                <v-icon>add</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card class="mt-1">
          <v-data-table
            :headers="headers"
            :items="blackList.ip"
            :search="search"
            class="pf-data-table" 
            :pagination.sync="pagination"
          >
            <template v-slot:items="props">
              <td>{{ props.index + 1 }}</td>
              <td>{{ props.item.ip }}</td>
              <td align="right">
                <v-btn icon class="ma-0" @click="deleteItem(props.item)">
                  <v-icon size="22" color="grey darken-2">delete_outline</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          </v-card>
          </v-container>
    </div>
</template>

<script>
/* global config session store  */
import swal from 'sweetalert2';
// import { mapGetters } from 'vuex';
import { getCollection, request, update } from '../../helpers/helpers';

const IPV4RegEx = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export default {
  name: 'ip-blacklist',
  data: () => ({
    blackList: {
      ip: []
    },
    ipRules: [
      v => !!v || 'IP address is required',
      v => {
        if (v && v.length) {
          let valid = true;
          v.forEach(ip => {
            if (!ip.match(IPV4RegEx)) {
              valid = false;
            }
          });
          return valid || 'Invalid IP address';
        }
        return true;
      }
    ],
    headers: [
      { text: '#', value: '', align: 'left' },
      { text: 'IP Address', value: 'ip', align: 'left' },
      { text: '', sortable: false },
    ],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: ''
    },
    search: ''
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    Agency: {
      set (value) {
        store.commit('setAgency', value);
      },
      get () {
        return store.state.Agency;
      }
    }
  },
  async created () {
    window.getApp.$emit('pageSubHeader', 'IP Blacklist');

    /* Fetch the admin menu settings */
    await this.fetchBlacklist();

    this.settingsBackup = JSON.parse(JSON.stringify(this.blackList));
  },
  methods: {
    async fetchBlacklist () {
      if (this.Agency.is_super_admin) {
        let { error, data, status } = await getCollection('Agency', true, 0, '', { is_super_admin: true }, 'blacklist');
        if (error) {
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to fetch the admin settings'
          };
        } else {
          data = data && data.length ? data[0] : null;
          if (data && data.blacklist && data.blacklist.ip) {
            this.blackList.ip = data.blacklist.ip.map(ip => {
              return {
                ip: ip
              };
            });
          }
        }
      }
    },
    addIP () {
      swal.fire({
        title: 'Add IP Address',
        input: 'text',
        inputAttributes: {
          autocapitalize: 'off'
        },
        showCancelButton: true,
        confirmButtonText: 'Add',
        showLoaderOnConfirm: true,
        preConfirm: (ip) => {
          if (!ip.match(IPV4RegEx)) {
            swal.showValidationMessage('Invalid IP address');
          }
          return ip;
        },
        allowOutsideClick: () => !swal.isLoading()
      }).then((result) => {
        if (result.value) {
          this.blackList.ip.push({ ip: result.value });
          this.save();
        }
      });
    },
    deleteItem (item) {
      swal.fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.value) {
          let index = this.blackList.ip.indexOf(item);
          this.blackList.ip.splice(index, 1);
          this.save();
        }
      });
    },
    async save () {
      if (this.blackList.ip) {
        const ips = this.blackList.ip.map(ip => ip.ip);
        let { error, data, status } = await request('Cloudflare/Blacklist/IP', 'POST', { ip: ips });
        if (error) {
          console.log('error', error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to update the data'
          };
        } else {
          /* Update the state */
          this.Agency.blacklist = ips;
          swal.fire({
            type: 'success',
            title: 'Blacklist updated successfully',
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
              // 
            }
          });
        }
      }
    }
  }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/pages/Settings/blacklist.vue